// extracted by mini-css-extract-plugin
export default {"currency":"currency-input_currency__Jo4Ws"};